import { SVGProps } from 'react';

export const HeartIcon = ({ ...rest }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.4785 5.20255L12.0006 5.70766L12.5221 5.20196C12.9952 4.74321 13.5608 4.37744 14.1867 4.12754C14.8127 3.87762 15.4855 3.74902 16.1656 3.75001H16.1667C18.9981 3.75001 21.25 5.91957 21.25 8.54401C21.25 10.99 19.8069 13.2975 18.0796 15.2273C16.3373 17.1733 14.1947 18.8558 12.5755 20.0624C12.4146 20.1821 12.2121 20.25 12 20.25C11.7879 20.25 11.5854 20.1821 11.4245 20.0623C9.80555 18.8559 7.66304 17.1736 5.91907 15.2277C4.19314 13.2976 2.75 10.9901 2.75 8.54401C2.75 5.91957 5.00185 3.75001 7.83333 3.75001C9.26274 3.75001 10.5548 4.30889 11.4785 5.20255Z"
        stroke="#1A1919"
        strokeWidth="1.5"
      />
    </svg>
  );
};
